import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import useFeatureFlagsService from '@/services/feature-flags.service'
import { FEATURE_FLAGS_QUERY_KEY } from '@/constants/QueryKeys'
import { useAuthStore } from '@/stores/auth.js'
import { ACCOUNT_PROVISIONING_STATUS } from '@/constants/Account'

/**
 * Account Feature Flags Query.
 *
 * @param {Object} [queryOptions] - Optional query options to customize the behavior of the query.
 * @returns {Object} - Returns the result of the `useQuery` hook, including the feature flags data and query status.
 */
const useAccountFeatureFlagsQuery = (queryOptions = undefined) => {
  const { getFeatureFlags } = useFeatureFlagsService()
  const authStore = useAuthStore()

  // @IMPORTANT This query should only be enabled for fully provisioned accounts (status === COMPLETED)
  // This is necessary as the query can be invoked throughout the application components such as the navbar that is
  // loaded during the onboarding process (before the account is provisioned).
  const isEnabled = computed(() => {
    return (
      !!authStore.account?.id !== null &&
      authStore.account.status == ACCOUNT_PROVISIONING_STATUS.COMPLETED
    )
  })

  return useQuery({
    queryKey: [FEATURE_FLAGS_QUERY_KEY],
    queryFn: async () => {
      return getFeatureFlags()
    },
    enabled: isEnabled,
    ...queryOptions
  })
}

export default useAccountFeatureFlagsQuery
